// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import useReportApi from "@store/Framework/Common/Hooks/useReportAPI/useReportAPI";
import { isPoPickerModel } from "@store/Framework/Services/Reporting/ReportingTypeGuards";
import { reportParametersSelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportOrderFrequency/ReportOrderFrequencySelectors";
import useUpdateReportSearchFields from "@store/Framework/Store/Bunzl/Pages/Reporting/StoreHooks/useUpdateSearchFields";
import ModalPicker from "@store/Library/Components/Reporting/ModalPicker/ModalPicker";
import usePO from "@store/Library/Components/Reporting/ModalPicker/useCheckboxPicker";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function POPicker() {
    const [poData, setPoData] = useState<string[]>([]);
    const updateReportSearchFields = useUpdateReportSearchFields();

    const { selectedItems, toggleItem, toggleAllItems, setSelectedItems } = usePO();
    const { updateData, isLoading, poError } = useReportApi("invoiceSummaryPoPicker");
    const reportApiParams = useSelector(reportParametersSelector);
    const onOpen = async () => {
        const data = await updateData({ ...reportApiParams, reportName: "invoiceSummaryPoPicker" });
        if (isPoPickerModel(data)) {
            setPoData(data.pos);
            setSelectedItems(selectedItems.filter(item => data.pos.includes(item)));
        } else {
            // clear the PO picker if no PONumbers are returned
            setPoData([]);
        }
    };
    useEffect(() => {
        updateReportSearchFields({
            ...reportApiParams,
            PONumbers: selectedItems,
        });
    }, [selectedItems]);
    const { customers } = useSelector(reportParametersSelector);

    return (
        <ModalPicker
            data={poData}
            toggleAllItems={toggleAllItems}
            header={translate("PO Number")}
            error={poError && customers.length === 0}
            onOpen={onOpen}
            isLoading={isLoading}
            selectedItems={selectedItems}
            toggleItem={toggleItem}
        />
    );
}

export default POPicker;
